// extracted by mini-css-extract-plugin
module.exports = {"cardInfo":"styles_cardInfo__1h8XZ","card":"styles_card__30mRd"};